// ToggleSettingCard.js
import React from 'react';
import PropTypes from "prop-types";
const ToggleSettingCard = ({
  title,
  description,
  isChecked,
  settingSlug,
  onToggle,
}) => {
  return (
    <div className={`rounded p-1 mb-1 `}>
      <div className="col-12 mb-1 ">
        <h6 className='password-change-option'><strong>{title}</strong></h6>
        <div className='d-flex justify-content-between'>
        <p className="mb-1 text-muted">{description}</p>
        <div className="form-check form-switch d-flex align-items-center justify-content-end">
          <input
            className="form-check-input cursor-pointer"
            type="checkbox"
            checked={isChecked}
            onChange={() => onToggle(settingSlug)}
          />
        </div>
        </div>
      </div>

    </div>
  );
};

ToggleSettingCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onToggle: PropTypes.func,
  isChecked: PropTypes.bool.isRequired,
settingSlug : PropTypes.string,
};

export default ToggleSettingCard;
